import {SmartComponent} from "smart-component-js";
import Swiper, {Navigation, Pagination} from "swiper";


class QuizComponent extends SmartComponent {
    constructor(element, parentComponent, params) {
        super(element, parentComponent, params);
        this.element = element;
        this.init();
    }


    init() {
        document.addEventListener('yxp-form-submit-ok', (e) => {
            this.element.classList.add('yxpLoading');
            this.showThankyou(e);
        });
    }

    showThankyou() {
        window.location.href = '/it/quiz-thank-you-page';
    }

}

export default QuizComponent;
